import React, { useState, useEffect } from "react";
import YouTube from 'react-youtube';
import axios from 'axios';
import "./Tutoriales.css";
import { PageBase } from "../../Components/PageBase";
import ojoCerrado from "../../icons/eye-off-outline.svg";
import ojoAbierto from "../../icons/eye-outline3.svg";
import back from '../../icons/chevron-back.svg';
import forward from '../../icons/chevron-forward.svg';
import noVisto from '../../icons/eye-off-outline-tutoriales.svg';
import visto from '../../icons/eye-outline-movil.svg';
import { useRol } from "../../Context";


function Tutoriales() {

    const { rol } = useRol()

    const [activeTab, setActiveTab] = useState('todos');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };



    const [videosInfo, setVideosInfo] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [watchedVideos, setWatchedVideos] = useState([]);
    const [unwatchedVideos, setUnwatchedVideos] = useState([]);

    useEffect(() => {

        const storedWatchedVideos = JSON.parse(localStorage.getItem('watchedVideos')) || [];
        const storedUnwatchedVideos = JSON.parse(localStorage.getItem('unwatchedVideos')) || [];

        setWatchedVideos(storedWatchedVideos);
        setUnwatchedVideos(storedUnwatchedVideos);

        const fetchData = async () => {
            try {
                const apiUrl = '/api/app/videos/';
                const response = await axios.get(apiUrl);
                const videosData = response.data;
                const filteredVideos = videosData.filter(video => {
                    if (rol === 'Asesor') {
                        return video.id >= 3 && video.id <= 9;
                    } else if (rol === 'Coordinador' || rol === 'Administrador') {
                        return video.id >= 10 && video.id <= 19;
                    }
                    return false;
                });

                const sortedVideos = filteredVideos.sort((a, b) => a.id - b.id);

                const videosInfoData = sortedVideos.map(video => {
                    return {
                        id: video.url,
                        title: video.title,
                        published: video.upload_date,
                        description: video.description,
                        watched: storedWatchedVideos.some(watchedVideo => watchedVideo.id === video.url),
                    };
                });

                setVideosInfo(videosInfoData);

                if (!storedWatchedVideos.length && !storedUnwatchedVideos.length) {
                    setUnwatchedVideos(videosInfoData);
                }
            } catch (error) {
                console.error('Error al obtener información de los videos', error);
            }
        };

        fetchData();
    }, [rol]);


    const [estado1, setEstado1] = useState(0);
    const [estado2, setEstado2] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            const anchoPantalla = window.innerWidth;

            if (anchoPantalla < 780) {
                setEstado1(1);
                setEstado2(0);
            } else {
                setEstado1(0);
                setEstado2(1);
            }
        };
        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const videoOptions = {
        height: '300',
        width: '777',
        playerVars: {
            autoplay: estado2,
        },
    };

    const videoOptionsMovil = {
        height: '240',
        width: '100%',
        playerVars: {
            autoplay: estado1,
            controls: 1,
            modestbranding: 1
        },
    };

    useEffect(() => {
        localStorage.setItem('watchedVideos', JSON.stringify(watchedVideos));
        localStorage.setItem('unwatchedVideos', JSON.stringify(unwatchedVideos));
    }, [watchedVideos, unwatchedVideos]);

    useEffect(() => {
        if (unwatchedVideos.length > 0) {
            const firstUnwatchedVideo = unwatchedVideos[0];
            playVideo(firstUnwatchedVideo);
        }
    }, [unwatchedVideos]);

    const handleVideoEnd = () => {
        setVideosInfo((prevVideosInfo) => {
            const updatedVideosInfo = [...prevVideosInfo];
            const selectedVideoIndex = updatedVideosInfo.findIndex(
                (video) => video.id === selectedVideo.id
            );

            updatedVideosInfo[selectedVideoIndex] = {
                ...updatedVideosInfo[selectedVideoIndex],
                watched: true,
            };
            return updatedVideosInfo;
        });

        setWatchedVideos((prevWatchedVideos) => [
            ...prevWatchedVideos,
            selectedVideo,
        ]);

        setUnwatchedVideos((prevUnwatchedVideos) =>
            prevUnwatchedVideos.filter((video) => video.id !== selectedVideo.id)
        );

        if (unwatchedVideos.length > 1) {
            const nextUnwatchedVideo = unwatchedVideos[1];
            playVideo(nextUnwatchedVideo);
        } else {
            setSelectedVideo(null);
        }
    };

    const handleVideoClick = (videoId) => {
        const clickedVideo = videosInfo.find((video) => video.id === videoId);
        playVideo(clickedVideo);
    };

    const playVideo = (video) => {
        setSelectedVideo(video);
    };

    const playPreviousVideo = () => {
        const currentIndex = unwatchedVideos.findIndex(
            (video) => video.id === selectedVideo.id
        );

        if (currentIndex > 0) {
            const previousVideo = unwatchedVideos[currentIndex - 1];
            playVideo(previousVideo);
        }
    };

    const playNextVideo = () => {
        const currentIndex = unwatchedVideos.findIndex(
            (video) => video.id === selectedVideo.id
        );

        if (currentIndex < unwatchedVideos.length - 1) {
            const nextVideo = unwatchedVideos[currentIndex + 1];
            playVideo(nextVideo);
        }
    };

    const formatoFecha = (fechaString) => {
        const fecha = new Date(fechaString);
        const meses = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];
        const dia = fecha.getDate();
        const mes = meses[fecha.getMonth()];
        const año = fecha.getFullYear();
        return `${dia} de ${mes} de ${año}`;
    }

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="tutoriales-page-container">
                    <div className="lista-reproduccion">
                        <div className="encabezados-status">
                            <div
                                className={`encabezados-tab ${activeTab === 'todos' ? 'activeT' : ''}`}
                                onClick={() => handleTabClick('todos')}
                            >
                                Todos
                            </div>
                            <div
                                className={`encabezados-tab ${activeTab === 'pendientes' ? 'activeT' : ''}`}
                                onClick={() => handleTabClick('pendientes')}
                            >
                                Pendientes
                            </div>
                            <div
                                className={`encabezados-tab ${activeTab === 'completados' ? 'activeT' : ''}`}
                                onClick={() => handleTabClick('completados')}
                            >
                                Completados
                            </div>
                        </div>
                        <div className="contenido">
                            {activeTab === 'todos' && <div className="contenido-detalles">
                                {videosInfo.map((video) => (
                                    <div className="card-info-video" key={video.id}>
                                        <label className="modulo-label" onClick={() => handleVideoClick(video.id)}>{video.title}</label>
                                        <p>{video.description}</p>
                                        <div className="detalles-inferior">
                                            <div className="visto">
                                                {video.watched === false && <button><img src={ojoCerrado} alt="no-visto" /> No visto</button>}
                                                {video.watched && <button id="watch"><img src={ojoAbierto} alt="visto" />Visto</button>}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>}
                            {activeTab === 'pendientes' && <div className="contenido-detalles">
                                {unwatchedVideos.map((video) => (
                                    <div className="card-info-video" key={video.id}>
                                        <label className="modulo-label" onClick={() => handleVideoClick(video.id)}>{video.title}</label>
                                        <p>{video.description}</p>
                                        <div className="detalles-inferior">
                                            <div className="visto">
                                                <button><img src={ojoCerrado} alt="no-visto" /> No visto</button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>}
                            {activeTab === 'completados' && <div className="contenido-detalles">
                                {watchedVideos.map((video) => (
                                    <div className="card-info-video" key={video.id}>
                                        <label className="modulo-label" onClick={() => handleVideoClick(video.id)}>{video.title}</label>
                                        <p>{video.description}</p>
                                        <div className="detalles-inferior">
                                            <div className="visto">
                                                <button id="watch"><img src={ojoAbierto} alt="visto" />Visto</button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>}
                        </div>
                    </div>
                    <div className="video-controles">
                        {selectedVideo && (<div>
                            <div className="video">
                                <YouTube
                                    videoId={selectedVideo.id}
                                    onEnd={handleVideoEnd}
                                    opts={videoOptions}
                                />
                            </div>
                            <div className="video-controles-detalles">
                                <h1>{selectedVideo.title}</h1>
                                <p>Publicado: {formatoFecha(selectedVideo.published)}</p>
                                <p>{selectedVideo.description}</p>
                            </div>
                        </div>
                        )}
                        <div className="video-controles-buttons">
                            <button id="back" onClick={playPreviousVideo}>
                                <img src={back} alt="" />
                                <label>Anterior</label>
                            </button>
                            <button id="forward" onClick={playNextVideo}>
                                <label>Siguiente</label>
                                <img src={forward} alt="" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tutoriales-movil">
                <div className="tutoriales-container-movil">
                    {selectedVideo && (
                        <div className="videoMovil" style={{ width: '100%', maxWidth: '800px', margin: '0 auto', height: '240px' }}>
                            <YouTube
                                videoId={selectedVideo.id}
                                onEnd={handleVideoEnd}
                                opts={videoOptionsMovil}
                            />
                        </div>
                    )}
                </div>
                <div className="scroll-container">
                    <div className="video-info">
                        {selectedVideo && (<div>
                            <div className="video-buttons">
                                <label className="video-titulo">{selectedVideo.title}</label>
                            </div>
                            <div className="descripcion-video">
                                <p>Publicado: {formatoFecha(selectedVideo.published)}</p>
                                <p>{selectedVideo.description}</p>
                            </div>
                        </div>
                        )}
                        <div className="butons-avanzar-retrocerder video-buttons">
                            <button id="back" onClick={playPreviousVideo}>
                                <img src={back} alt="" />
                                <label>Anterior</label>
                            </button>
                            <button id="forward" onClick={playNextVideo}>
                                <label>Siguiente</label>
                                <img src={forward} alt="" />
                            </button>
                        </div>
                    </div>
                    <div className="buttons-status-container-tutoriales sticky-element">
                        <div className="container-buttons-lead-movil">
                            <div className={`opcion ${activeTab === 'todos' ? "seleccionado-movil" : ""} status-videos-tutoriales-movil`} onClick={() => handleTabClick('todos')}>
                                <label>Todos</label>
                            </div>
                            <div className={`opcion ${activeTab === 'pendientes' ? "seleccionado-movil" : ""} status-videos-tutoriales-movil`} onClick={() => handleTabClick('pendientes')}>
                                <label>Pendientes</label>
                            </div>
                            <div className={`opcion ${activeTab === 'completados' ? "seleccionado-movil" : ""} status-videos-tutoriales-movil ultimo-grid-tutoriales`} onClick={() => handleTabClick('completados')}>
                                <label>Completados</label>
                            </div>
                        </div>
                    </div>
                    <div className="auto-scroll-div">
                        {activeTab === 'todos' && <div className="lista-videos-miniatura">
                            {videosInfo.map((video) => (
                                <div className="card-video-tutoriales" key={video.id}>
                                    <div className="detalles-video-miniatura" onClick={() => handleVideoClick(video.id)}>
                                        <label className="titulo-video-miniatura">{video.title}</label>
                                        <label className="detalles-miniatura">{video.description}</label>
                                        <div className="video-status-detalles">
                                            {video.watched === false && <img src={noVisto} alt="" />}
                                            {video.watched && <img src={visto} alt="" />}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>}
                        {activeTab === 'pendientes' && <div className="lista-videos-miniatura">
                            {unwatchedVideos.map((video) => (
                                <div className="card-video-tutoriales" key={video.id}>
                                    <div className="detalles-video-miniatura" onClick={() => handleVideoClick(video.id)}>
                                        <label className="titulo-video-miniatura">{video.title}</label>
                                        <label className="detalles-miniatura">{video.description}</label>
                                        <div className="video-status-detalles">
                                            <img src={noVisto} alt="" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>}
                        {activeTab === 'completados' && <div className="lista-videos-miniatura">
                            {watchedVideos.map((video) => (
                                <div className="card-video-tutoriales" key={video.id}>
                                    <div className="detalles-video-miniatura" onClick={() => handleVideoClick(video.id)}>
                                        <label className="titulo-video-miniatura">{video.title}</label>
                                        <label className="detalles-miniatura">{video.description}</label>
                                        <div className="video-status-detalles">
                                            <img src={visto} alt="" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>}
                    </div>
                </div>
            </div>
        </>
    )
}

export { Tutoriales }